
import { FormField, FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";
import { EntryFormValues } from "./EntryEditDialog";

interface EntryMetadataFieldsProps {
  control: Control<EntryFormValues>;
}

const EntryMetadataFields = ({ control }: EntryMetadataFieldsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={control}
        name="height"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Height</FormLabel>
            <FormControl>
              <Input {...field} placeholder="e.g., 60 cm" />
            </FormControl>
          </FormItem>
        )}
      />
      
      <FormField
        control={control}
        name="weight"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Weight</FormLabel>
            <FormControl>
              <Input {...field} placeholder="e.g., 5.2 kg" />
            </FormControl>
          </FormItem>
        )}
      />
      
      <FormField
        control={control}
        name="diaperChanges"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Diaper Changes</FormLabel>
            <FormControl>
              <Input {...field} placeholder="e.g., 6 times" />
            </FormControl>
          </FormItem>
        )}
      />
      
      <FormField
        control={control}
        name="milkIntake"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Milk Intake</FormLabel>
            <FormControl>
              <Input {...field} placeholder="e.g., 150 ml" />
            </FormControl>
          </FormItem>
        )}
      />
      
      <FormField
        control={control}
        name="milestone"
        render={({ field }) => (
          <FormItem className="md:col-span-2">
            <FormLabel>Milestone</FormLabel>
            <FormControl>
              <Input {...field} placeholder="e.g., First smile, Rolling over" />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
};

export default EntryMetadataFields;
